@if (form) {
<form [formGroup]="form">
    <header>Perspectiva</header>
    <mat-accordion displayMode="flat" [multi]="true">
        @if (allowedFilters.length > 0) {
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>filter_list</mat-icon> Filtros ({{ value.filters.length }})
                </mat-panel-title>
            </mat-expansion-panel-header>
            <section class="content" formArrayName="filters">
                @for (filter of filters.controls; track filter; let i = $index) {
                <div class="fieldGroup" [class.valid]="filter.valid" [formGroupName]="i">
                    <div class="filterGroup">
                        <mat-form-field>
                            <mat-select
                                placeholder="Campo"
                                formControlName="filter"
                                (selectionChange)="onFilterChange(filter)"
                            >
                                @for (allowedFilter of allowedFilters; track allowedFilter) {
                                <mat-option [value]="allowedFilter">
                                    {{ allowedFilter.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <button mat-icon-button tabindex="-1" (click)="removeFilter(i)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    @if (isText(filter)) {
                    <div class="valueGroup textValue">
                        <mat-form-field class="operation auto-width">
                            <mat-select formControlName="operation">
                                @for (op of operations.text; track op) {
                                <mat-option [value]="op.value">
                                    {{ op.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="value">
                            <input matInput placeholder="Valor" formControlName="value" />
                        </mat-form-field>
                    </div>
                    } @if (isNumeric(filter)) {
                    <div class="valueGroup textValue">
                        <mat-form-field class="operation auto-width">
                            <mat-select formControlName="operation">
                                @for (op of operations.number; track op) {
                                <mat-option [value]="op.value">
                                    {{ op.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="value">
                            <input
                                matInput
                                type="number"
                                placeholder="Valor"
                                formControlName="value"
                            />
                        </mat-form-field>
                    </div>
                    } @if (isBoolean(filter)) {
                    <div class="valueGroup textValue">
                        <mat-form-field class="value auto-width">
                            <mat-select formControlName="value">
                                <mat-option [value]="true"> Sim </mat-option>
                                <mat-option [value]="false"> Não </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    } @if (isReference(filter)) {
                    <div class="valueGroup refValue">
                        <mat-form-field class="operation auto-width">
                            <mat-select formControlName="operation">
                                @for (op of operations.reference; track op) {
                                <mat-option [value]="op.value">
                                    {{ op.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <app-data-selector
                            formControlName="value"
                            class="value auto-width"
                            [repository]="filter.value.filter.repository"
                            label="Selecione"
                        ></app-data-selector>
                    </div>
                    } @if (isEnum(filter)) {
                    <div class="valueGroup textValue">
                        <mat-form-field class="operation auto-width">
                            <mat-select formControlName="operation">
                                @for (op of operations.enum; track op) {
                                <mat-option [value]="op.value">
                                    {{ op.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="value auto-width">
                            <mat-select formControlName="value">
                                @for (value of filter.value.filter.values; track value) {
                                <mat-option [value]="value.name">
                                    {{ value.label || value.name || value }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }
                </div>
                }
            </section>
        </mat-expansion-panel>
        } @if (allowedSorts.length > 0) {
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>sort</mat-icon> Ordenação ({{ value.sorts.length }})
                </mat-panel-title>
            </mat-expansion-panel-header>
            <section class="content" formArrayName="sorts">
                @for (sort of sorts.controls; track sort; let i = $index) {
                <div class="fieldGroup" [class.valid]="sort.valid" [formGroupName]="i">
                    <div class="sortGroup">
                        <mat-form-field class="auto-width">
                            <mat-select placeholder="Campo" formControlName="field">
                                @for (allowedSort of allowedSorts; track allowedSort) {
                                <mat-option [value]="allowedSort">
                                    {{ allowedSort.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (sort?.value?.field) {
                        <mat-form-field class="auto-width">
                            <mat-select formControlName="value">
                                <mat-option [value]="0"> Crescente </mat-option>
                                <mat-option [value]="1"> Decrescente </mat-option>
                            </mat-select>
                        </mat-form-field>
                        }
                        <button mat-icon-button tabindex="-1" (click)="removeSort(i)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </section>
        </mat-expansion-panel>
        } @if (showSettings) {
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header
                ><mat-panel-title
                    ><mat-icon>settings</mat-icon> Definições</mat-panel-title
                ></mat-expansion-panel-header
            >
            <section class="content" formGroupName="settings">
                @if (showActives) {
                <mat-form-field>
                    <mat-label>Exibir registros</mat-label>
                    <select matNativeControl formControlName="actives">
                        @for (option of activesOptions; track option) {
                        <option [value]="option.value">
                            {{ option.name }}
                        </option>
                        }
                    </select>
                </mat-form-field>
                }
            </section>
        </mat-expansion-panel>
        }
    </mat-accordion>
</form>
}
